<template>
    <section class="roadmap-sec">
         <h2>از ثبت نام تا اجرای تبلیغ</h2>
         <img :src="imageSrc" alt="" class="roadmap-img"/>
    </section>
</template>

<script>
import { computed, inject } from 'vue';
export default {
    name: "AdRoadmap",

    setup() {
        const width = inject('viewportWidth');

        const imageSrc = computed(() => {
        return width.value > 768 ? require('@/assets/images/roadmap.png') : require('@/assets/images/roadmap-mobile.png')
        });

        return {
            imageSrc,
        }

    }
};
</script>

<style scoped>
.roadmap-sec {
    margin-inline: 11.81%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.roadmap-sec h2 {
    font-family: 'IRANYekan-Bold';
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 3.46%;
}

.roadmap-img {
    width: 100%;
    max-height: 266px;
    object-fit: contain;
    animation: fadeIn 3s ease-out forwards;
}

@media screen and (min-width: 1441px) {
    .roadmap-sec {
        width: 1100px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .roadmap-sec h2 {
        font-size: 24px;
        line-height: 28px;
    }
}

@media screen and (max-width: 768px) {
    .roadmap-sec {
        margin-inline: 9.03%;
    }

    .roadmap-sec h2 {
        margin-bottom: 24px;
    }

    .roadmap-img {
        max-height: 602px;
    }
}

@media screen and (max-width: 375px) {
    .roadmap-sec h2 {
        font-size: 20px;
    }
}
</style>